import { useEffect, useState } from 'react';

import { getPrimaryImages } from '../utils/api';
import { BASE_URL } from '../utils/constants';

export const useSliderImages = () => {
  const [content, setContent] = useState<object[]>([]);
  const [images, setImages] = useState<string[]>([]);

  const getSliderImages = () => {
    getPrimaryImages()
      .then((data) => setContent(data))
      .catch((err) => console.log('err', err));
  };

  useEffect(() => {
    getSliderImages();
  }, []);

  useEffect(() => {
    if (content?.length) {
      const list = content.reduce((res: string[], item) => {
        // @ts-ignore
        const key = item?.Key.split('/')[1].split('.')[0];

        if (key) {
          // @ts-ignore
          res.push(`${BASE_URL}/${item.Key}`);
        }
        return res;
      }, []);

      const sorted = list.sort((a, b) => {
        const regex = /[^/]+(?=\.[^.]*$)/g;
        return Number(a.match(regex)) - Number(b.match(regex));
      });

      setImages(sorted);
    }
  }, [content]);

  return images;
};
